webpackJsonp([14,46],{

/***/ 18:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_swiper__ = __webpack_require__(1);


var breakpoint = window.matchMedia('(max-width: 767px)');
var aboutValues = void 0;
var aboutServices = void 0;

var carouselProperties = {
  aboutValuesSlide: {
    slidesPerView: 1,
    slidesPerGroup: 1,
    spaceBetween: 0,
    autoplay: {
      delay: 3000
    },
    pagination: {
      el: '.swiper-pagination--values',
      type: 'bullets',
      clickable: true
    },
    breakpoints: {
      0: {
        slidesPerView: 1,
        slidesPerGroup: 1
      }
    }
  },
  aboutServicesSlide: {
    slidesPerView: 1,
    slidesPerGroup: 1,
    spaceBetween: 0,
    autoplay: {
      delay: 3000
    },
    pagination: {
      el: '.swiper-pagination--services',
      type: 'bullets',
      clickable: true
    },
    breakpoints: {
      0: {
        slidesPerView: 1,
        slidesPerGroup: 1
      }
    }
  }
};

var aboutSlide = function aboutSlide() {
  aboutValues = new __WEBPACK_IMPORTED_MODULE_0_swiper__["a" /* default */]('.swiper-container--about', carouselProperties.aboutValuesSlide);
};
var servicesSlide = function servicesSlide() {
  aboutServices = new __WEBPACK_IMPORTED_MODULE_0_swiper__["a" /* default */]('.swiper-container--services', carouselProperties.aboutServicesSlide);
};

var breakpointChecker = function breakpointChecker() {
  if (breakpoint.matches === false) {
    if (aboutValues !== undefined) {
      aboutValues.destroy(true, true);
      aboutServices.destroy(true, true);
      $('.swiper-pagination--values').html('');
      $('.swiper-pagination--services').html('');
      return;
    }
  }if (breakpoint.matches === true) {
    aboutSlide();
    servicesSlide();
  }
};

breakpoint.addListener(breakpointChecker);

/* harmony default export */ __webpack_exports__["default"] = (breakpointChecker);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0)))

/***/ }),

/***/ 46:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__aboutSlider__ = __webpack_require__(18);


document.addEventListener('DOMContentLoaded', function () {
  // About
  Object(__WEBPACK_IMPORTED_MODULE_0__aboutSlider__["default"])();
});

/***/ })

},[46]);


// WEBPACK FOOTER //
// about/about-b2846f0c56137ae2b674.js